<!-- src/views/pages/finance-accounts/payroll/payroll-additions.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportAdditionsCsv"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportAdditionsExcel"
                  >
                    <i class="ti ti-file-spreadsheet me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap gy-2 justify-content-between my-4">
        <div class="payroll-btns">
          <router-link to="/payroll/payroll" class="btn btn-white border me-2">
            Payments
          </router-link>
          <router-link
            to="/payroll/payroll-overtime"
            class="btn btn-white border me-2"
          >
            Overtime
          </router-link>
          <router-link
            to="/payroll/payroll-deduction"
            class="btn btn-white border me-2"
          >
            Deductions
          </router-link>
          <router-link
            to="/payroll/period-adjustments"
            class="btn btn-white border"
          >
            Optional Monthly Adjustments
          </router-link>
        </div>
        <div class="mb-2">
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#add_payroll"
            class="btn btn-primary d-flex align-items-center"
            @click="onAddNew"
            v-can="'Payroll.Create'"
          >
            <i class="ti ti-circle-plus me-2"></i>Add Payment
          </a>
        </div>
      </div>

      <!-- Payroll list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Payments List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'recent'">
                    Recently Added
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_asc'">
                    Name A-Z
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'name_desc'">
                    Name Z-A
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click.prevent="sortOption = 'amount_desc'">
                    Highest Amount
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="sortedAdditions"
              :row-selection="rowSelection"
              :loading="loading"
              row-key="id"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                  <h6 class="fs-14 fw-medium text-gray-9">
                    {{ record.name }}
                  </h6>
                </template>
                <template v-else-if="column.key === 'category'">
                  <span>{{ record.category || "-" }}</span>
                </template>
                <template v-else-if="column.key === 'default_amount'">
                  <span>{{ record.default_amount }}</span>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_payroll"
                      @click="onEdit(record)"
                      v-can="'Payroll.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a href="javascript:void(0);" @click="onDelete(record)" v-can="'Payroll.Delete'">
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Payroll list -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <payroll-modal
    ref="additionModal"
    @refreshAdditions="fetchAll"
  ></payroll-modal>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { usePayrollAdditionStore } from "@/stores/payrollAdditionStore";
import { exportRowsAsCsv, exportRowsAsExcel } from "@/utils/payrollListExport";

// Static table config
const columns = [
  {
    sorter: false,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    sorter: (a, b) => (a.category || "").localeCompare(b.category || ""),
  },
  {
    title: "Default/Unit Amount",
    dataIndex: "default_amount",
    key: "default_amount",
    sorter: (a, b) => (a.default_amount || 0) - (b.default_amount || 0),
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// Page text
const title = ref("Payroll Components");
const text = ref("Payroll Company Settings");
const text1 = ref("Payments");
const sortOption = ref("recent");

// Modal ref
const additionModal = ref(null);

// Store
const payrollAdditionStore = usePayrollAdditionStore();
const { additions, loading } = storeToRefs(payrollAdditionStore);
const { deleteAddition, fetchAll } = payrollAdditionStore;

const sortLabel = computed(() => {
  switch (sortOption.value) {
    case "name_asc":
      return "Name A-Z";
    case "name_desc":
      return "Name Z-A";
    case "amount_desc":
      return "Highest Amount";
    default:
      return "Recently Added";
  }
});

const sortedAdditions = computed(() => {
  const list = Array.isArray(additions.value) ? [...additions.value] : [];

  switch (sortOption.value) {
    case "name_asc":
      return list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    case "name_desc":
      return list.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    case "amount_desc":
      return list.sort(
        (a, b) => Number(b.default_amount || 0) - Number(a.default_amount || 0),
      );
    default:
      return list.sort(
        (a, b) =>
          new Date(b.created_at || 0).getTime() -
          new Date(a.created_at || 0).getTime(),
      );
  }
});

// Lifecycle
onMounted(() => {
  fetchAll();
});

// Methods
const toggleHeader = () => {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
};

const onAddNew = () => {
  additionModal.value?.resetForm();
};

const onEdit = (record) => {
  additionModal.value?.openForEdit(record);
};

const onDelete = async (record) => {
  additionModal.value?.openForDelete(record);
};

const exportAdditionsCsv = () => {
  exportRowsAsCsv(
    "payroll-additions.csv",
    ["Name", "Category", "Amount", "Assignment"],
    sortedAdditions.value.map((item) => [
      item.name,
      item.category || "-",
      item.default_amount ?? 0,
      item.assignee_type || "all",
    ]),
  );
};

const exportAdditionsExcel = () => {
  exportRowsAsExcel(
    "payroll-additions.xls",
    ["Name", "Category", "Amount", "Assignment"],
    sortedAdditions.value.map((item) => [
      item.name,
      item.category || "-",
      item.default_amount ?? 0,
      item.assignee_type || "all",
    ]),
  );
};
</script>


